/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type OutputImageDynamicPartStatus =
  (typeof OutputImageDynamicPartStatus)[keyof typeof OutputImageDynamicPartStatus];

export const OutputImageDynamicPartStatus = {
  pending: "pending",
  success: "success",
  failed: "failed",
} as const;
